(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  class BlogPageSection extends HTMLElement {
    constructor() {
      super();

      this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
    }

    connectedCallback() {
      this.articlesContainer = this.querySelector('[data-blog-articles]');
      this.paginationContainer = this.querySelector('[data-blog-pagination]');
      this.loadMoreButton = this.querySelector('[data-blog-load-more]');
      this.loadMoreButton?.addEventListener('click', this.onLoadMoreClick);
    }

    disconnectedCallback() {
      this.loadMoreButton?.removeEventListener('click', this.onLoadMoreClick);
    }

    async onLoadMoreClick(event) {
      if (!this.loadMoreButton || !this.articlesContainer) return;

      event.preventDefault();

      const nextUrl = this.loadMoreButton.getAttribute('href');
      if (!nextUrl) return;

      this.loadMoreButton.classList.add('is-loading');
      this.loadMoreButton.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Could not load more articles.');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextItems = doc.querySelectorAll('[data-blog-article-item]');
        const nextButton = doc.querySelector('[data-blog-load-more]');

        nextItems.forEach((item) => {
          this.articlesContainer.appendChild(document.importNode(item, true));
        });

        if (nextButton) {
          this.loadMoreButton.setAttribute('href', nextButton.getAttribute('href'));
        } else {
          this.paginationContainer?.remove();
          this.loadMoreButton = null;
        }
      } catch (error) {
        window.location.href = nextUrl;
      } finally {
        this.loadMoreButton?.classList.remove('is-loading');
        this.loadMoreButton?.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('blog-page-section')) {
    customElements.define('blog-page-section', BlogPageSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionDataProvider extends HTMLElement {
    constructor() {
      super();
      this.productsContainer = this.querySelector('#CollectionProducts');
      this.gridDisplay = this.querySelector('#CollectionGridDisplay');
      this.listDisplay = this.querySelector('#CollectionListDisplay');
      
      this.nextUrl = this.dataset.nextUrl || null;
      this.activeMode = 'grid';
      this.activeFilters = {};
      this.allProductsLoaded = !this.nextUrl;
      this.isLoading = false;
      this.preloadPromise = null;

      this.initFilterListener();
      this.initClearFiltersListener();
      this.initModeSwitcher();
      this.initLoadMoreListener();

      this.queueInitialStateDispatch();
    }

    getFilterUtils() {
      const fallback = {
        normalizeOperator(operator) {
          if (operator === '<' || operator === '>' || operator === '=') return operator;
          return '=';
        },

        normalizeCriteria(criteria) {
          if (!Array.isArray(criteria)) return [];

          return criteria
            .map((criterion) => {
              if (typeof criterion === 'object' && criterion !== null) {
                return {
                  value: criterion.value?.toString().toLowerCase().trim() || '',
                  operator: this.normalizeOperator(criterion.operator)
                };
              }

              return {
                value: criterion?.toString().toLowerCase().trim() || '',
                operator: '='
              };
            })
            .filter((criterion) => criterion.value !== '');
        },

        buildCriteria(values, operators) {
          if (!Array.isArray(values)) return [];

          return values
            .map((value, index) => {
              const normalizedValue = value?.toString().toLowerCase().trim() || '';
              const operator = Array.isArray(operators)
                ? this.normalizeOperator(operators[index])
                : '=';

              return {
                value: normalizedValue,
                operator
              };
            })
            .filter((criterion) => criterion.value !== '');
        }
      };

      const globalUtils = window.CollectionFilterUtils;
      if (
        globalUtils &&
        typeof globalUtils.normalizeOperator === 'function' &&
        typeof globalUtils.normalizeCriteria === 'function' &&
        typeof globalUtils.buildCriteria === 'function'
      ) {
        return globalUtils;
      }

      return fallback;
    }

    initFiltersFromQueryParams() {
      const filterUtils = this.getFilterUtils();

      const search = window.location?.search || '';
      if (!search) return;

      const searchParams = new URLSearchParams(search);
      const queryParamToFilterType = {
        installation: 'installation-types',
        'installation-type': 'installation-types',
        'installation-types': 'installation-types',
        installation_types: 'installation-types',
        feature: 'feature',
        features: 'feature',
        material: 'material',
        materials: 'material',
        shape: 'shape',
        style: 'style',
        color: 'color',
        width: 'width-inch',
        'width-inch': 'width-inch',
        height: 'height-inch',
        'height-inch': 'height-inch',
        depth: 'depth-inch',
        'depth-inch': 'depth-inch'
      };

      const criteriaByFilter = {};
      const addCriterion = (filterType, value, operator) => {
        if (!criteriaByFilter[filterType]) {
          criteriaByFilter[filterType] = [];
        }

        const hasSameCriterion = criteriaByFilter[filterType].some((criterion) => {
          return criterion.value === value && criterion.operator === operator;
        });

        if (!hasSameCriterion) {
          criteriaByFilter[filterType].push({ value, operator });
        }
      };

      searchParams.forEach((rawValue, rawParam) => {
        const param = rawParam?.toString().toLowerCase().trim() || '';
        const filterType = queryParamToFilterType[param];
        if (!filterType) return;

        const values = rawValue
          .toString()
          .split(',')
          .map((value) => value.toLowerCase().trim())
          .filter((value) => value !== '');

        values.forEach((value) => {
          let operator = '=';
          let normalizedValue = value;

          if (normalizedValue.startsWith('<')) {
            operator = '<';
            normalizedValue = normalizedValue.slice(1).trim();
          } else if (normalizedValue.startsWith('>')) {
            operator = '>';
            normalizedValue = normalizedValue.slice(1).trim();
          }

          if (!normalizedValue) return;
          addCriterion(filterType, normalizedValue, filterUtils.normalizeOperator(operator));
        });
      });

      Object.keys(criteriaByFilter).forEach((filterType) => {
        const values = criteriaByFilter[filterType].map((criterion) => criterion.value);
        const operators = criteriaByFilter[filterType].map((criterion) => criterion.operator);
        const criteria = filterUtils.buildCriteria(values, operators);
        if (criteria.length > 0) {
          this.activeFilters[filterType] = criteria;
        }
      });
    }

    getFiltersSnapshot() {
      const filterUtils = this.getFilterUtils();
      const snapshot = {};

      Object.keys(this.activeFilters).forEach((filterType) => {
        const criteria = this.activeFilters[filterType];
        const normalizedCriteria = filterUtils.normalizeCriteria(criteria);

        if (normalizedCriteria.length > 0) {
          snapshot[filterType] = normalizedCriteria;
        }
      });

      return snapshot;
    }

    hasActiveFilters() {
      return Object.keys(this.getFiltersSnapshot()).length > 0;
    }

    dispatchInitialData() {
      // Signal that initial data is ready (already rendered by Liquid)
      this.dispatchEvent(new CustomEvent('collection:data-ready', {
        detail: {
          hasMore: !!this.nextUrl,
          activeFilters: this.getFiltersSnapshot()
        },
        bubbles: true
      }));
    }

    queueInitialStateDispatch() {
      // Ensure display components have attached listeners before first dispatch.
      window.setTimeout(() => {
        this.initFiltersFromQueryParams();
        this.dispatchInitialData();

        if (this.hasActiveFilters()) {
          this.preloadAllProductsForFiltering().then(() => {
            this.dispatchFilterChanged();
          });
        }
      }, 0);
    }

    initLoadMoreListener() {
      document.addEventListener('collection:request-more', async (e) => {
        if (this.isLoading) return;
        await this.loadMoreFromServer();
      });
    }

    initFilterListener() {
      document.addEventListener('collection:filter-interface-change', async (event) => {
        await this.onFilterInterfaceChange(event);
      });
    }

    initClearFiltersListener() {
      document.addEventListener('collection:clear-filters-request', async () => {
        await this.onClearFiltersRequest();
      });
    }

    initModeSwitcher() {
      document.addEventListener('mode-change', (e) => {
        this.setViewMode(e.detail.mode);
      });
    }

    setLoading(isLoading) {
      this.isLoading = isLoading;
      if (this.productsContainer) {
        this.productsContainer.classList.toggle('collection__products--loading', isLoading);
      }
      
      this.dispatchEvent(new CustomEvent('collection:loading', {
        detail: { isLoading },
        bubbles: true
      }));
    }

    async loadMoreFromServer() {
      if (!this.nextUrl || this.isLoading) return;

      this.setLoading(true);

      try {
        const response = await fetch(this.nextUrl);
        if (!response.ok) throw new Error('Network response was not ok');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Extract new products HTML for grid
        const newGridProducts = Array.from(doc.querySelectorAll('#CollectionGrid > *'))
          .map(el => el.outerHTML);
        
        // Extract new products HTML for list
        const newListProducts = Array.from(doc.querySelectorAll('#CollectionList > *'))
          .map(el => el.outerHTML);

        // Update next URL
        const nextDataProvider = doc.querySelector('collection-data-provider');
        this.nextUrl = nextDataProvider?.dataset.nextUrl || null;
        
        if (!this.nextUrl) {
          this.allProductsLoaded = true;
        }

        // Dispatch new data to display components
        this.dispatchEvent(new CustomEvent('collection:new-data', {
          detail: {
            gridProducts: newGridProducts,
            listProducts: newListProducts,
            hasMore: !!this.nextUrl,
            activeFilters: this.getFiltersSnapshot(),
            advancePage: true,
            source: 'load-more'
          },
          bubbles: true
        }));

      } catch (error) {
        console.error('Error loading more products:', error);
      } finally {
        this.setLoading(false);
      }
    }

    async preloadAllProductsForFiltering() {
      if (this.allProductsLoaded) return;

      if (this.preloadPromise) {
        return this.preloadPromise;
      }

      this.preloadPromise = this.loadAllProductsForFiltering();

      try {
        await this.preloadPromise;
      } finally {
        this.preloadPromise = null;
      }
    }

    async loadAllProductsForFiltering() {
      if (this.allProductsLoaded || this.isLoading) return;
      
      this.setLoading(true);
      
      while (this.nextUrl) {
        try {
          const response = await fetch(this.nextUrl);
          if (!response.ok) break;

          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Extract new products HTML
          const newGridProducts = Array.from(doc.querySelectorAll('#CollectionGrid > *'))
            .map(el => el.outerHTML);
          const newListProducts = Array.from(doc.querySelectorAll('#CollectionList > *'))
            .map(el => el.outerHTML);

          // Update next URL
          const nextDataProvider = doc.querySelector('collection-data-provider');
          this.nextUrl = nextDataProvider?.dataset.nextUrl || null;
          
          if (!this.nextUrl) {
            this.allProductsLoaded = true;
          }

          // Dispatch new data
          this.dispatchEvent(new CustomEvent('collection:new-data', {
            detail: {
              gridProducts: newGridProducts,
              listProducts: newListProducts,
              hasMore: !!this.nextUrl,
              activeFilters: this.getFiltersSnapshot(),
              advancePage: false,
              source: 'filter-preload'
            },
            bubbles: true
          }));

        } catch (error) {
          console.error('Error loading all products:', error);
          break;
        }
      }
      
      this.setLoading(false);
    }

    setViewMode(mode) {
      this.activeMode = mode;
      
      if (mode === 'list') {
        this.gridDisplay?.classList.add('collection-display--hidden');
        this.listDisplay?.classList.remove('collection-display--hidden');
      } else {
        this.gridDisplay?.classList.remove('collection-display--hidden');
        this.listDisplay?.classList.add('collection-display--hidden');
      }

      // Notify displays of mode change
      this.dispatchEvent(new CustomEvent('collection:mode-changed', {
        detail: { mode },
        bubbles: true
      }));
    }

    dispatchFilterChanged() {
      this.dispatchEvent(new CustomEvent('collection:filter-changed', {
        detail: {
          activeFilters: this.getFiltersSnapshot(),
          hasMore: !!this.nextUrl
        },
        bubbles: true
      }));
    }

    async onFilterInterfaceChange(event) {
      const filterUtils = this.getFilterUtils();
      const filterType = event?.detail?.filterType;
      const values = event?.detail?.values;
      const operators = event?.detail?.operators;
      if (!filterType) return;
      if (!Array.isArray(values)) return;

      const normalizedFilterType = filterType.toString().toLowerCase().trim();
      if (!normalizedFilterType) return;

      const normalizedCriteria = filterUtils.buildCriteria(values, operators);

      if (normalizedCriteria.length > 0) {
        this.activeFilters[normalizedFilterType] = normalizedCriteria;
      } else {
        delete this.activeFilters[normalizedFilterType];
      }

      // Load all products first if any filter is active and not all are loaded.
      if (this.hasActiveFilters()) {
        await this.preloadAllProductsForFiltering();
      }

      this.dispatchFilterChanged();
    }

    async onClearFiltersRequest() {
      this.activeFilters = {};

      this.dispatchEvent(new CustomEvent('collection:filters-cleared', {
        bubbles: true
      }));

      this.dispatchFilterChanged();
    }
  }

  if (!customElements.get('collection-data-provider')) {
    customElements.define('collection-data-provider', CollectionDataProvider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
  function initContactFormValidation() {
    document.querySelectorAll('.contact-page__form').forEach((form) => {
      const fields = form.querySelectorAll('input, select, textarea');
      const formReadyAt = Date.now();
      const minimumSubmitDelay = 3000;
      const auxiliaryField = form.querySelector('[data-contact-auxiliary-field]');
      const spamMessage = form.querySelector('[data-contact-spam-message]');

      const hideSpamMessage = () => {
        if (spamMessage) {
          spamMessage.hidden = true;
        }
      };

      const showSpamMessage = () => {
        if (spamMessage) {
          spamMessage.hidden = false;
          spamMessage.focus({ preventScroll: true });
        }
      };

      const getValidationMessage = (field) => {
        if (field.validity.valueMissing) {
          return field.dataset.requiredMessage || '';
        }

        if (field.validity.typeMismatch) {
          return field.dataset.emailMessage || '';
        }

        return '';
      };

      const updateValidityMessage = (field) => {
        field.setCustomValidity('');

        if (!field.validity.valid) {
          field.setCustomValidity(getValidationMessage(field));
        }
      };

      fields.forEach((field) => {
        field.addEventListener('invalid', () => updateValidityMessage(field));
        field.addEventListener('input', () => {
          field.setCustomValidity('');
          updateValidityMessage(field);
        });
        field.addEventListener('change', () => {
          field.setCustomValidity('');
          updateValidityMessage(field);
        });
      });

      form.addEventListener('submit', (event) => {
        const auxiliaryFieldHasValue = auxiliaryField && auxiliaryField.value.trim() !== '';
        const submittedTooQuickly = Date.now() - formReadyAt < minimumSubmitDelay;

        if (auxiliaryFieldHasValue || submittedTooQuickly) {
          event.preventDefault();
          showSpamMessage();
          return;
        }

        hideSpamMessage();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactFormValidation);
  } else {
    initContactFormValidation();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-desktop"]) return;
  try {
    
  const header = document.querySelector('.header__menu__desktop__tablet');
  const quoteBadge = header?.querySelector('[data-quote-badge]');
  const productsMenu = document.querySelector('.header__products-menu');
  const productsModal = document.getElementById('HeaderProductsModal');
  const productsBackdrop = document.querySelector('.header__products-backdrop');
  let closeProductsMenuTimeout = null;
  const originalFetch = window.fetch.bind(window);

  const getQuoteBundleCount = (cart) => {
    return (cart.items || []).reduce((count, item) => {
      const bundleRole = item.properties?._bundle_role || item.properties?.bundle_role;
      return bundleRole === 'main' ? count + 1 : count;
    }, 0);
  };

  const renderQuoteBadge = (count) => {
    if (!quoteBadge) return;

    quoteBadge.textContent = String(count);

    if (count > 0) {
      quoteBadge.classList.remove('header__quote-link-badge--hidden');
    } else {
      quoteBadge.classList.add('header__quote-link-badge--hidden');
    }
  };

  const refreshQuoteBadge = async () => {
    try {
      const response = await originalFetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      renderQuoteBadge(getQuoteBundleCount(cart));
    } catch (error) {
      // Ignore badge refresh failures to avoid interrupting add-to-cart flows.
    }
  };

  const isCartAddRequest = (url) => {
    if (!url) return false;
    return url.includes('/cart/add');
  };

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const [input] = args;
    const url = typeof input === 'string' ? input : input?.url;

    if (response.ok && isCartAddRequest(url)) {
      refreshQuoteBadge();
    }

    return response;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.__quoteBadgeCartUrl = typeof url === 'string' ? url : '';
    return originalXHROpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function(body) {
    this.addEventListener('load', () => {
      if (this.status >= 200 && this.status < 300 && isCartAddRequest(this.__quoteBadgeCartUrl)) {
        refreshQuoteBadge();
      }
    });

    return originalXHRSend.call(this, body);
  };

  if (productsMenu && productsModal && productsBackdrop) {
    const openProductsMenu = () => {
      if (closeProductsMenuTimeout) {
        clearTimeout(closeProductsMenuTimeout);
      }

      document.documentElement.classList.add('header-products-open');
      productsModal.setAttribute('aria-hidden', 'false');
      productsBackdrop.setAttribute('aria-hidden', 'false');
    };

    const closeProductsMenu = () => {
      if (closeProductsMenuTimeout) {
        clearTimeout(closeProductsMenuTimeout);
      }

      closeProductsMenuTimeout = setTimeout(() => {
        document.documentElement.classList.remove('header-products-open');
        productsModal.setAttribute('aria-hidden', 'true');
        productsBackdrop.setAttribute('aria-hidden', 'true');
      }, 60);
    };

    productsMenu.addEventListener('mouseenter', openProductsMenu);
    productsMenu.addEventListener('mouseleave', closeProductsMenu);
    productsModal.addEventListener('mouseenter', openProductsMenu);
    productsModal.addEventListener('mouseleave', closeProductsMenu);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.documentElement.classList.remove('header-products-open');
      productsModal.setAttribute('aria-hidden', 'true');
      productsBackdrop.setAttribute('aria-hidden', 'true');
    });

    const tabletBreakpoint = Number.parseInt(header.dataset.tabletBreakpoint, 10) || 768;
    window.addEventListener('resize', () => {
      if (window.innerWidth > tabletBreakpoint) return;
      document.documentElement.classList.remove('header-products-open');
      productsModal.setAttribute('aria-hidden', 'true');
      productsBackdrop.setAttribute('aria-hidden', 'true');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
  const menuToggle = document.getElementById('MobileMenuToggle');
  const menuOverlay = document.getElementById('MobileMenuOverlay');

  if (menuToggle && menuOverlay) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuOverlay.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.documentElement.classList.toggle('overflow-hidden', isOpen);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-our-products"]) return;
  try {
    
  class HomeOurProducts extends HTMLElement {
    constructor() {
      super();

      this.onCategoryClick = this.onCategoryClick.bind(this);
      this.onPreviousClick = this.onPreviousClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onCarouselScroll = this.onCarouselScroll.bind(this);
      this.onWindowResize = this.onWindowResize.bind(this);
      this.onWheel = this.onWheel.bind(this);
    }

    connectedCallback() {
      this.categories = [...this.querySelectorAll('.home-our-products__category')];
      this.carouselInner = this.querySelector('.home-our-products__carousel-inner');
      this.carousel = this.querySelector('.home-our-products__carousel');
      this.previousButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      this.categoryTemplates = new Map(
        [...this.querySelectorAll('template[data-category-template]')]
          .map(template => [template.dataset.categoryTemplate, template])
      );

      this.categories.forEach(category => {
        category.addEventListener('click', this.onCategoryClick);
      });

      this.previousButton?.addEventListener('click', this.onPreviousClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.carouselInner?.addEventListener('scroll', this.onCarouselScroll, { passive: true });
      this.carouselInner?.addEventListener('wheel', this.onWheel, { passive: false });
      window.addEventListener('resize', this.onWindowResize);

      this.updateCarouselControls();
    }

    disconnectedCallback() {
      this.categories?.forEach(category => {
        category.removeEventListener('click', this.onCategoryClick);
      });

      this.previousButton?.removeEventListener('click', this.onPreviousClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.carouselInner?.removeEventListener('scroll', this.onCarouselScroll);
      this.carouselInner?.removeEventListener('wheel', this.onWheel);
      window.removeEventListener('resize', this.onWindowResize);
    }

    onCategoryClick(event) {
      const category = event.currentTarget;
      const type = category.dataset.category;

      if (category.classList.contains('home-our-products__category--active')) return;

      // Update UI
      this.categories.forEach(cat => cat.classList.remove('home-our-products__category--active'));
      category.classList.add('home-our-products__category--active');

      this.carousel.classList.add('is-loading');

      // Use setTimeout to allow the loading state to render
      setTimeout(() => {
        this.renderCategory(type);
        this.carousel.classList.remove('is-loading');
        this.updateCarouselControls();
      }, 100);
    }

    renderCategory(type) {
      const template = this.categoryTemplates.get(type);
      if (!template || !this.carouselInner) return;

      this.carouselInner.replaceChildren(template.content.cloneNode(true));

      // Reset scroll position immediately even though the carousel uses smooth scrolling elsewhere.
      const previousScrollBehavior = this.carouselInner.style.scrollBehavior;
      this.carouselInner.style.scrollBehavior = 'auto';
      this.carouselInner.scrollLeft = 0;
      this.carouselInner.style.scrollBehavior = previousScrollBehavior;
      window.requestAnimationFrame(() => this.updateCarouselControls());
    }

    updateCarouselControlPosition() {
      if (!this.carouselInner || !this.carousel) return;

      const firstTile = this.carouselInner.querySelector('.product-tile');
      const visualTarget = firstTile?.querySelector('.product-tile__image-wrapper') || firstTile;
      if (!visualTarget) return;

      const carouselRect = this.carousel.getBoundingClientRect();
      const visualRect = visualTarget.getBoundingClientRect();
      const visualCenter = visualRect.top + (visualRect.height / 2) - carouselRect.top;
      this.carousel.style.setProperty('--carousel-control-top', `${visualCenter}px`);
    }

    getScrollStep() {
      const firstTile = this.carouselInner?.querySelector('.product-tile');
      if (!firstTile) return this.carouselInner?.clientWidth || 0;

      const styles = window.getComputedStyle(this.carouselInner);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return firstTile.getBoundingClientRect().width + gap;
    }

    scrollByStep(direction) {
      if (!this.carouselInner) return;

      this.carouselInner.scrollBy({
        left: this.getScrollStep() * direction,
        behavior: 'smooth'
      });
    }

    onPreviousClick() {
      this.scrollByStep(-1);
    }

    onNextClick() {
      this.scrollByStep(1);
    }

    onCarouselScroll() {
      this.updateCarouselControls();
    }

    onWindowResize() {
      window.requestAnimationFrame(() => this.updateCarouselControls());
    }

    updateCarouselControls() {
      if (!this.carouselInner || !this.carousel) return;

      this.updateCarouselControlPosition();

      const maxScrollLeft = this.carouselInner.scrollWidth - this.carouselInner.clientWidth;
      const isScrollable = maxScrollLeft > 1;
      const isAtStart = this.carouselInner.scrollLeft <= 1;
      const isAtEnd = this.carouselInner.scrollLeft >= maxScrollLeft - 1;

      this.carousel.classList.toggle('is-scrollable', isScrollable);

      if (this.previousButton) {
        this.previousButton.disabled = !isScrollable || isAtStart;
        this.previousButton.setAttribute('aria-hidden', (!isScrollable).toString());
      }

      if (this.nextButton) {
        this.nextButton.disabled = !isScrollable || isAtEnd;
        this.nextButton.setAttribute('aria-hidden', (!isScrollable).toString());
      }
    }

    onWheel(event) {
      if (!this.carouselInner) return;
      if (Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

      const maxScrollLeft = this.carouselInner.scrollWidth - this.carouselInner.clientWidth;
      const direction = Math.sign(event.deltaY);
      const canScrollLeft = this.carouselInner.scrollLeft > 1;
      const canScrollRight = this.carouselInner.scrollLeft < maxScrollLeft - 1;

      if ((direction < 0 && !canScrollLeft) || (direction > 0 && !canScrollRight)) return;

      event.preventDefault();
      this.carouselInner.scrollLeft += event.deltaY;
    }

  }

  if (!customElements.get('home-our-products-section')) {
    customElements.define('home-our-products-section', HomeOurProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspiration"]) return;
  try {
    
  class InspirationPageSection extends HTMLElement {
    constructor() {
      super();

      this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
      this.onSectionClick = this.onSectionClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.grid = this.querySelector('[data-inspiration-grid]');
      this.columns = this.getColumns();
      this.renderedItemKeys = this.getRenderedItemKeys();
      this.paginationContainer = this.querySelector('[data-inspiration-pagination]');
      this.loadMoreButton = this.querySelector('[data-inspiration-load-more]');
      this.imageModal = this.querySelector('[data-inspiration-image-modal]');
      this.imageModalImage = this.querySelector('[data-inspiration-image-modal-image]');
      this.imageModalClose = this.querySelector('[data-inspiration-image-close]');
      this.loadMoreButton?.addEventListener('click', this.onLoadMoreClick);
      this.addEventListener('click', this.onSectionClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.loadMoreButton?.removeEventListener('click', this.onLoadMoreClick);
      this.removeEventListener('click', this.onSectionClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    getColumns() {
      return Array.from(this.querySelectorAll('[data-inspiration-column]'));
    }

    getRenderedItemKeys() {
      return new Set(
        Array.from(this.querySelectorAll('[data-inspiration-item]'))
          .map((item) => item.dataset.inspirationItemKey)
          .filter(Boolean)
      );
    }

    onSectionClick(event) {
      const imageButton = event.target.closest('[data-inspiration-image-open]');
      if (imageButton && this.contains(imageButton)) {
        this.openImageModal(imageButton);
        return;
      }

      if (event.target.closest('[data-inspiration-image-close]')) {
        this.closeImageModal();
        return;
      }

      if (this.imageModal && event.target === this.imageModal) {
        this.closeImageModal();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.imageModal && !this.imageModal.hidden) {
        this.closeImageModal();
      }
    }

    openImageModal(button) {
      if (!this.imageModal || !this.imageModalImage) return;

      const imageSrc = button.dataset.inspirationImageSrc;
      if (!imageSrc) return;

      this.activeImageButton = button;
      this.previousBodyOverflow = document.body.style.overflow;
      this.previousDocumentOverflow = document.documentElement.style.overflow;
      this.imageModalImage.src = imageSrc;
      this.imageModalImage.alt = button.dataset.inspirationImageAlt || '';
      this.imageModal.hidden = false;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      this.imageModalClose?.focus();
    }

    closeImageModal() {
      if (!this.imageModal || !this.imageModalImage || this.imageModal.hidden) return;

      this.imageModal.hidden = true;
      this.imageModalImage.removeAttribute('src');
      this.imageModalImage.alt = '';
      document.body.style.overflow = this.previousBodyOverflow || '';
      document.documentElement.style.overflow = this.previousDocumentOverflow || '';
      this.activeImageButton?.focus();
      this.activeImageButton = null;
      this.previousBodyOverflow = null;
      this.previousDocumentOverflow = null;
    }

    async onLoadMoreClick(event) {
      if (!this.loadMoreButton || !this.grid || this.isLoading) return;

      event.preventDefault();

      const nextUrl = this.loadMoreButton.getAttribute('href');
      if (!nextUrl) return;

      this.isLoading = true;
      this.loadMoreButton.classList.add('is-loading');
      this.loadMoreButton.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Could not load more inspiration items.');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = doc.querySelector('inspiration-page-section');
        const nextButton = nextSection?.querySelector('[data-inspiration-load-more]');

        nextSection?.querySelectorAll('[data-inspiration-column]').forEach((nextColumn) => {
          const columnIndex = nextColumn.dataset.inspirationColumn;
          const currentColumn = this.columns.find((column) => column.dataset.inspirationColumn === columnIndex);
          if (!currentColumn) return;

          nextColumn.querySelectorAll('[data-inspiration-item]').forEach((item) => {
            const itemKey = item.dataset.inspirationItemKey;
            if (itemKey && this.renderedItemKeys.has(itemKey)) return;

            currentColumn.appendChild(document.importNode(item, true));

            if (itemKey) {
              this.renderedItemKeys.add(itemKey);
            }
          });
        });

        if (nextButton) {
          this.loadMoreButton.setAttribute('href', nextButton.getAttribute('href'));
        } else {
          this.paginationContainer?.remove();
          this.loadMoreButton = null;
        }
      } catch (error) {
        window.location.href = nextUrl;
      } finally {
        this.isLoading = false;
        this.loadMoreButton?.classList.remove('is-loading');
        this.loadMoreButton?.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('inspiration-page-section')) {
    customElements.define('inspiration-page-section', InspirationPageSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPageScroll extends HTMLElement {
    constructor() {
      super();
      this.mediaQuery = window.matchMedia('(min-width: 1101px)');
      this.rafId = null;
      this.resizeObserver = null;
      this.pendingImages = [];
      this.contentHeight = 0;
      this.requestUpdate = this.requestUpdate.bind(this);
      this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleGalleryImageLoad = this.handleGalleryImageLoad.bind(this);
    }

    connectedCallback() {
      this.mediaColumn = this.querySelector('.product-page__media-column');
      this.gallery = this.querySelector('.product-page__gallery');
      this.contentColumn = this.querySelector('.product-page__content-column');

      if (!this.mediaColumn || !this.gallery || !this.contentColumn) {
        return;
      }

      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
      } else {
        this.mediaQuery.addListener(this.handleMediaQueryChange);
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.requestUpdate);
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.mediaColumn);
        this.resizeObserver.observe(this.gallery);
        this.resizeObserver.observe(this.contentColumn);
      }

      this.initializeGalleryImageLoading();

      this.requestUpdate();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.requestUpdate);
      window.removeEventListener('resize', this.handleResize);

      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
      } else {
        this.mediaQuery.removeListener(this.handleMediaQueryChange);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.pendingImages.forEach((image) => {
        image.removeEventListener('load', this.handleGalleryImageLoad);
        image.removeEventListener('error', this.handleGalleryImageLoad);
      });

      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
      }
    }

    handleMediaQueryChange() {
      this.contentHeight = 0;
      this.requestUpdate();
    }

    handleResize() {
      this.contentHeight = 0;
      this.requestUpdate();
    }

    initializeGalleryImageLoading() {
      this.gallery.classList.add('is-image-loading-enabled');
      this.pendingImages = Array.from(this.gallery.querySelectorAll('.product-page__gallery-image'));

      this.pendingImages.forEach((image) => {
        if (image.complete) {
          this.markGalleryImageLoaded(image);
          return;
        }

        const galleryItem = image.closest('.product-page__gallery-item');

        if (galleryItem) {
          galleryItem.classList.add('is-image-loading');
        }

        image.addEventListener('load', this.handleGalleryImageLoad, { once: true });
        image.addEventListener('error', this.handleGalleryImageLoad, { once: true });
      });
    }

    handleGalleryImageLoad(event) {
      this.markGalleryImageLoaded(event.currentTarget);
      this.requestUpdate();
    }

    markGalleryImageLoaded(image) {
      const galleryItem = image.closest('.product-page__gallery-item');

      image.classList.add('is-loaded');

      if (galleryItem) {
        galleryItem.classList.remove('is-image-loading');
      }
    }

    requestUpdate() {
      if (this.rafId) {
        return;
      }

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    update() {
      if (!this.mediaQuery.matches) {
        this.reset();
        return;
      }

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const stickyTop = this.getStickyTop();
      const mediaStickyBottom = this.getMediaStickyBottom();
      const contentViewportHeight = Math.max(0, viewportHeight - stickyTop);
      const mediaHeight = this.gallery.offsetHeight;
      const contentHeight = this.getContentHeight();
      this.contentHeight = contentHeight;
      const mediaFitsViewport = mediaHeight + stickyTop + mediaStickyBottom <= viewportHeight;
      const mediaScrollDistance = mediaFitsViewport ? 0 : Math.max(0, mediaHeight + mediaStickyBottom - viewportHeight);
      const contentScrollDistance = Math.max(0, contentHeight - contentViewportHeight);
      const shouldSequence = mediaScrollDistance > 1 || contentScrollDistance > 1;

      if (!shouldSequence) {
        this.reset();
        return;
      }

      const scrollY = window.scrollY || window.pageYOffset;
      const sectionTop = this.getBoundingClientRect().top + scrollY;
      const stickyStart = sectionTop - stickyTop;
      const switchPoint = mediaFitsViewport ? stickyStart : sectionTop + mediaScrollDistance;
      const isContentFixed = scrollY >= stickyStart && scrollY < switchPoint;
      const isMediaSticky = scrollY >= switchPoint;
      const contentOffset = mediaFitsViewport ? 0 : Math.ceil(mediaScrollDistance + stickyTop);
      const contentLayoutHeight = Math.min(contentHeight, contentViewportHeight);
      const sectionLayoutHeight = Math.max(mediaHeight, contentLayoutHeight);
      const requiredSectionHeight = mediaFitsViewport
        ? contentHeight
        : mediaScrollDistance + contentScrollDistance + viewportHeight;
      const extraSpace = Math.max(0, Math.ceil(requiredSectionHeight - sectionLayoutHeight));
      const sectionHeight = sectionLayoutHeight + extraSpace;
      const mediaAnchorPoint = mediaFitsViewport
        ? Math.max(switchPoint, sectionTop + sectionHeight - mediaHeight - stickyTop)
        : Math.max(switchPoint, sectionTop + sectionHeight - viewportHeight + mediaStickyBottom);
      const contentRect = this.contentColumn.getBoundingClientRect();
      const mediaRect = this.mediaColumn.getBoundingClientRect();
      const isMediaTopFixed = mediaFitsViewport && scrollY >= switchPoint && scrollY < mediaAnchorPoint;
      const isMediaFixed = !mediaFitsViewport && scrollY >= switchPoint && scrollY < mediaAnchorPoint;
      const isMediaAnchored = scrollY >= mediaAnchorPoint;

      this.style.setProperty('--product-scroll-extra-space', `${extraSpace}px`);
      this.style.setProperty('--product-content-scroll-offset', `${contentOffset}px`);
      this.style.setProperty('--product-content-fixed-left', `${contentRect.left}px`);
      this.style.setProperty('--product-content-fixed-width', `${contentRect.width}px`);
      this.style.setProperty('--product-media-anchor-top', `${sectionHeight - mediaHeight}px`);
      this.style.setProperty('--product-media-fixed-left', `${mediaRect.left}px`);
      this.style.setProperty('--product-media-fixed-width', `${mediaRect.width}px`);
      this.style.setProperty('--product-media-height', `${mediaHeight}px`);
      this.style.setProperty('--product-top-layout-height', `${sectionLayoutHeight}px`);
      this.classList.add('is-scroll-sequenced');
      this.classList.toggle('is-content-fixed', isContentFixed);
      this.classList.toggle('is-scroll-initial', !isMediaSticky);
      this.classList.toggle('is-media-sticky', isMediaSticky);
      this.classList.toggle('is-media-top-fixed', isMediaTopFixed);
      this.classList.toggle('is-media-fixed', isMediaFixed);
      this.classList.toggle('is-media-anchored', isMediaAnchored);
    }

    reset() {
      this.style.removeProperty('--product-scroll-extra-space');
      this.style.removeProperty('--product-content-scroll-offset');
      this.style.removeProperty('--product-content-fixed-left');
      this.style.removeProperty('--product-content-fixed-width');
      this.style.removeProperty('--product-media-anchor-top');
      this.style.removeProperty('--product-media-fixed-left');
      this.style.removeProperty('--product-media-fixed-width');
      this.style.removeProperty('--product-media-height');
      this.style.removeProperty('--product-top-layout-height');
      this.classList.remove(
        'is-scroll-sequenced',
        'is-content-fixed',
        'is-scroll-initial',
        'is-media-sticky',
        'is-media-top-fixed',
        'is-media-fixed',
        'is-media-anchored'
      );
    }

    getStickyTop() {
      const stickyTop = parseFloat(getComputedStyle(this).getPropertyValue('--product-sticky-top'));

      if (Number.isFinite(stickyTop)) {
        return stickyTop;
      }

      return 109;
    }

    getMediaStickyBottom() {
      const mediaStickyBottom = parseFloat(getComputedStyle(this).getPropertyValue('--product-media-sticky-bottom'));

      if (Number.isFinite(mediaStickyBottom)) {
        return mediaStickyBottom;
      }

      return 20;
    }

    getContentHeight() {
      const childrenHeight = Array.from(this.contentColumn.children).reduce((height, child) => {
        return Math.max(height, child.offsetTop + child.offsetHeight);
      }, 0);

      return Math.max(this.contentColumn.scrollHeight, this.contentColumn.offsetHeight, childrenHeight);
    }
  }

  if (!customElements.get('product-page-scroll')) {
    customElements.define('product-page-scroll', ProductPageScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-request-sent"]) return;
  try {
    
  function showQuoteTrackingId() {
    document.querySelectorAll('[data-quote-tracking]').forEach((trackingElement) => {
      const trackingIdElement = trackingElement.querySelector('[data-quote-tracking-id]');
      const ecommerceId = (new URLSearchParams(window.location.search).get('ecommerceId') || '').trim();

      if (!trackingIdElement || !ecommerceId) {
        return;
      }

      trackingIdElement.textContent = ecommerceId;
      trackingElement.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showQuoteTrackingId);
  } else {
    showQuoteTrackingId();
  }

  } catch(e) { console.error(e); }
})();
})();
